
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pro/briefings",
      function () {
        return require("private-next-pages/pro/briefings/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pro/briefings"])
      });
    }
  